module.exports = __webpack_public_path__ + "static/standalone/img/product-transit.22e93050.svg";